import React, { useEffect, useState } from "react";
import back from "../../../assets/back.svg";
import edit from "../../../assets/icons/edit.svg";
import delet from "../../../assets/icons/delete-bin.svg";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import VersionHistoryBtn, {
  AdminButton,
} from "../../../components/buttons/versionHistoryBtn";
import DeleteModal from "../../../components/modals/deleteModal";
import { useDispatch } from "react-redux";
import {
  fieldForceFetchHeadQuarterDetail,
  fieldForceHeadQuarterDelete,
} from "../../../redux/actions/fieldForceAction";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import DeletedPopUp from "../../../components/popups/DeletedPopUp";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const FieldForceHeadQuarterView = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [headQuarterDetailsData, setheadQuarterDetailsData] = useState();
  const [deleteShow, setDeleteShow] = useState(false);
  const [deletedPop, setDeletedPop] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loding, setLoding] = useState(false);
  const [userData, setUserData] = useState(null);

  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Field Force" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  useEffect(() => {
    setLoding(true);
    dispatch(fieldForceFetchHeadQuarterDetail(params.id, onSuccess, onError));
  }, []);
  const onSuccess = (data) => {
    setLoding(false);
    setheadQuarterDetailsData(data?.data?.data);
  };
  const onError = (err) => {
    setLoding(false);
    console.log(err);
  };
  const delFunc = (id) => {
    dispatch(
      fieldForceHeadQuarterDelete(
        headQuarterDetailsData?.id,
        onDelSuccess,
        onDelError
      )
    );
  };

  const onDelSuccess = (data) => {
    setDeleteShow(false);
    setDeletedPop(true);

    const timeOutFnc = () => {
      setDeletedPop(false);
      navigate("/field-force/head-quarter");
    };

    setTimeout(timeOutFnc, 2000);
  };
  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onDelError = (err) => {
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Edit
    </Tooltip>
  );
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/field-force/head-quarter",
      breadcrumb: " / field force / head quarter",
    },
    {
      path: "/field-force/head-quarter/view/:id",
      breadcrumb: headQuarterDetailsData?.code
        ? ` / ${headQuarterDetailsData?.code} - view`
        : " / view",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between align-items-center">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
              <div className=" d-flex justify-content-between m-1 mb-2">
                <VersionHistoryBtn
                  link={`/field-force/head-quarter/version-view/${headQuarterDetailsData?.id}`}
                />
                {(user_type == "super_user" && userData?.write) ||
                user_type == "vendor" ? (
                  <>
                    <div className="d-none d-lg-block">
                      <div className="d-flex">
                        <AdminButton
                          background="#7065E4"
                          color="white"
                          width="100px"
                          onClick={() =>
                            navigate(
                              `/field-force/head-quarter/edit/${headQuarterDetailsData?.id}`
                            )
                          }
                        >
                          <span className="m-2">EDIT</span>
                        </AdminButton>
                        <AdminButton
                          background="#FF6F5B"
                          color="white"
                          width="100px"
                          onClick={() => {
                            setDeleteShow(true);
                          }}
                        >
                          <span className="m-2">DELETE</span>
                        </AdminButton>
                      </div>
                    </div>

                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip}
                    >
                      <button
                        className="edit-small-btn px-3 mx-1 d-lg-none"
                        onClick={() =>
                          navigate(
                            `/field-force/head-quarter-edit/${headQuarterDetailsData?.id}`
                          )
                        }
                      >
                        <img src={edit} alt="edit" />
                      </button>
                    </OverlayTrigger>
                    <button
                      className="delete-small-btn px-3 mx-2 me-3 d-lg-none"
                      onClick={() => setDeleteShow(true)}
                    >
                      <img src={delet} alt="delete" />
                    </button>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loding == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <div className="  ps-4 ps-lg-4 ms-3 mt-4 col-lg-5 col-md-6 col-10 ">
                  <div className="my-2">
                    <label className="color_747f9e fs_14">
                      Head Quarters ID
                    </label>
                    <p className="fs_14 color_262c3d">
                      {headQuarterDetailsData?.code
                        ? headQuarterDetailsData?.code
                        : "--"}
                    </p>
                  </div>
                  <div className="my-2">
                    <label className="color_747f9e fs_14">
                      Head Quarters Name
                    </label>
                    <p className="fs_14 color_262c3d">
                      {headQuarterDetailsData?.name
                        ? headQuarterDetailsData?.name
                        : "--"}
                    </p>
                  </div>
                  <div className="my-2">
                    <label className="color_747f9e fs_14">State</label>
                    <p className="fs_14 color_262c3d">
                      {headQuarterDetailsData?.state?.name
                        ? headQuarterDetailsData?.state?.name
                        : "--"}
                    </p>
                  </div>
                  <div className="my-2">
                    <label className="color_747f9e fs_14">District</label>
                    <p className="fs_14 color_262c3d">
                      {headQuarterDetailsData?.headQuaterDistricts?.length >
                        0 &&
                        headQuarterDetailsData?.headQuaterDistricts?.map(
                          (ele, index) => {
                            return (
                              <span className="slice-word" key={index}>
                                <span style={{ color: "#B0B3C7" }}>
                                  {index ? " | " : ""}
                                </span>
                                {ele?.district?.name
                                  ? ele?.district?.name
                                  : "--"}
                              </span>
                            );
                          }
                        )}
                    </p>
                  </div>
                  <div className="my-2">
                    <label className="color_747f9e fs_14">Status</label>
                    {headQuarterDetailsData?.status == true ? (
                      <p className="fs_14 color-green">Active</p>
                    ) : (
                      <p className="fs_14 color-danger">Inactive</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <DeleteModal
          show={deleteShow}
          title={`this Field Force Head Quater - ${headQuarterDetailsData?.code}`}
          handleClose={() => setDeleteShow(false)}
          delFunc={delFunc}
        />
        <DeletedPopUp
          title={`this Field Force Head Quater - ${headQuarterDetailsData?.code}`}
          show={deletedPop}
        />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default FieldForceHeadQuarterView;
